import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { performanceMarkInProd } from '@confluence/confluence-performance/entry-points/performanceMarkInProd.ts';
import type { ExternalShareContentRendererProps } from './types.ts';

const CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

const _default_1: LoadableType<ExternalShareContentRendererProps> = LoadableAfterPaint({
	name: 'ClassicContentRendererLoader',

	loader: async () => {
		performanceMarkInProd(`${CONTENT_RENDERER_DOWNLOAD}.start`);
		const module = await import(
			/* webpackChunkName: "loadable-ExternalShareContentRenderer" */ './ExternalShareContentRenderer.tsx'
		);
		performanceMarkInProd(`${CONTENT_RENDERER_DOWNLOAD}.end`);
		return module;
	},
});
export default _default_1;
